// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DownloadIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DownloadIcon" ref={forwardedRef} {...props}>
      <path d="M10.25 12.5 6.007 8.257l1.061-1.06L9.5 9.629V3.5H11v6.129l2.432-2.432 1.06 1.06z" />
      <path d="M15.498 15.497h-11V12h-1.5L3 15.998C3 16.551 3.392 17 3.875 17h12.25C16.608 17 17 16.551 17 15.998L16.999 12h-1.501z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DownloadIcon = /* @__PURE__ */ Object.assign(
  DownloadIconComponent,
  { displayName: 'DownloadIcon' },
);
